<template>
	<div id="app" style="height: 1900px;">
  <v-app id="inspire">
    <v-container>
          <DatePicker type="datetime" v-model="sendTime" placeholder="Select date and time" style="width: 200px"></DatePicker>
          <DatePicker type="datetime" disabled v-model="sendTime1" placeholder="Select date and time" style="width: 200px"></DatePicker>
          <DatePicker type="datetime" disabled v-model="sendTime2" placeholder="Select date and time" style="width: 200px"></DatePicker>
          <v-btn @click="getTimeAndPrice">send</v-btn>
          <div style="margin-top: 1800px;">
          	<v-flex >
              <v-btn ref="button" color="primary" block @click="$vuetify.goTo(0)">scroll</v-btn>
            </v-flex>
          </div>
    </v-container>
  </v-app>
</div>
</template>
<script>
const easings = {
  linear: '',
  easeInQuad: '',
  easeOutQuad: '',
  easeInOutQuad: '',
  easeInCubic: '',
  easeOutCubic: '',
  easeInOutCubic: '',
  easeInQuart: '',
  easeOutQuart: '',
  easeInOutQuart: '',
  easeInQuint: '',
  easeOutQuint: '',
  easeInOutQuint: ''
}
	export default{
		data () {
    return {
      type: 'number',
      number: 9999,
      selector: '#first',
      selected: 'Button',
      elements: ['Button', 'Radio group'],
      duration: 300,
      offset: 0,
      easing: 'easeInOutCubic',
      easings: Object.keys(easings),
      sendTime: null,
      sendTime1: null,
      sendTime2: null,
    }
  },
  computed: {
    target () {
      const value = this[this.type]
      if (!isNaN(value)) return Number(value)
      else return value
    },
    options () {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing
      }
    },
    element () {
      if (this.selected === 'Button') return this.$refs.button
      else if (this.selected === 'Radio group') return this.$refs.radio
    },
    
  },
  methods: {
    getTimeAndPrice(){
      let sendTimeStamp = this.sendTime.valueOf();
      // let recordTimeStamp = sendTimeStamp - 60*60*24*1000;
      let timeStamp1 = sendTimeStamp - 5*60*1000;
      let timeStamp2 = sendTimeStamp + 5*60*1000;
      this.$http.get("https://graphs2.coinmarketcap.com/currencies/bitcoin/"+ timeStamp1 +"/"+ timeStamp2 +"/").then(response => {
        let data = response.data;
        let price_usd = data.price_usd;
        let array1 = price_usd[0];
        let array2 = price_usd[1];
        let timeStamp1 = array1[0];
        let timeStamp2 = array2[0];
        this.sendTime1 = new Date(timeStamp1);
        this.sendTime2 = new Date(timeStamp2);
      });
    }
  }
	}
</script>


// WEBPACK FOOTER //
// Scrolling.vue?0552cc74